import { request } from '@umijs/max';

// 获取用户分页列表
export async function getUserPage(params: API.PageParams) {
  return request('/api/shop/user/page', {
    method: 'POST',
    data: params,
  });
}

// 获取用户详情
export async function getUserInfo(params: { id: number }) {
  return request('/api/shop/user/info', {
    method: 'POST',
    data: {
      ...params,
      with: ['shop', 'rentFiles', 'sfzFiles', 'hukouFiles', 'dibaoFiles', 'nengliFiles'],
    },
  });
}

// 获取COS文件真实访问链接
export async function getViewUrl(params: { url: string[] }) {
  return request('/api/shop/cos/viewUrl', {
    method: 'POST',
    data: params,
  });
}
